export interface ToolCall {
  name: string
  arguments: Record<string, unknown>
}

export interface ChatMessage {
  id: number
  role: 'user' | 'assistant' | 'system'
  content: string
  tool_calls?: ToolCall[]
  metadata?: {
    thinking_seconds?: number
    current_time?: number
  }
  created_at: string
}

export interface Conversation {
  id: number
  video_id: string
  messages: ChatMessage[]
  message_count: number
  created_at: string
  updated_at: string
}

export async function getConversations(videoId: string): Promise<Conversation[]> {
  const response = await fetch(`/api/videos/${videoId}/conversations`, {
    credentials: 'same-origin',
  })
  if (!response.ok) throw new Error('Failed to load conversations')
  return response.json()
}

export async function createConversation(videoId: string): Promise<Conversation> {
  const response = await fetch(`/api/videos/${videoId}/conversations`, {
    method: 'POST',
    credentials: 'same-origin',
  })
  if (!response.ok) throw new Error('Failed to create conversation')
  return response.json()
}

export async function getConversation(
  videoId: string,
  conversationId: number,
): Promise<Conversation> {
  const response = await fetch(
    `/api/videos/${videoId}/conversations/${conversationId}`,
    { credentials: 'same-origin' },
  )
  if (!response.ok) throw new Error('Failed to load conversation')
  return response.json()
}

export async function sendChatMessage(
  videoId: string,
  conversationId: number,
  message: string,
  currentTime?: number,
): Promise<{ message: ChatMessage; conversation: Conversation }> {
  const response = await fetch(
    `/api/videos/${videoId}/conversations/${conversationId}/messages`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ message, current_time: currentTime }),
    },
  )
  if (!response.ok) throw new Error('Failed to send message')
  return response.json()
}
